export default "__VITE_ASSET__926d5865__"